// extracted by mini-css-extract-plugin
export default {"box":"couponPage_box__sJtJq"};